// extracted by mini-css-extract-plugin
export var cardIcon = "_6g-5";
export var cardIconUnframed = "_6g-9";
export var checkboxCard = "_6g-0";
export var checkboxCardSelected = "_6g-4";
export var disabled = "_6g-2";
export var interactive = "_6g-1";
export var outerBorder = "_6g-3";
export var spacerMedium = "_6g-8";
export var spacerSmall = "_6g-7";
export var spacerXsmall = "_6g-6";